/* ============================================================
   Sattika — theme.js
   Three jobs only:
   1. Variant switching and live price on the product page
   2. Finishing add-ons: adds the saree AND the chosen add-on
      products in one /cart/add.js call, linked by a line-item
      property so you can see on the order which saree they belong to
   3. Small conveniences: quantity steppers, gallery, mobile filters
   ============================================================ */
(function () {
  'use strict';

  var S = window.SattikaSettings || {};

  function money(cents) {
    var fmt = S.moneyFormat || '₹{{amount}}';
    var n = (cents / 100);
    var whole = Math.round(n * 100) / 100;
    var str = whole.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, str);
  }

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var form = btn.closest('form');
    var input = form && form.querySelector('[data-qty-input]');
    if (!input) return;
    var next = parseInt(input.value, 10) + parseInt(btn.dataset.qty, 10);
    input.value = next < 1 ? 1 : next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart line quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-qty]');
    if (!btn) return;
    var wrapEl = btn.closest('.qty');
    var input = wrapEl && wrapEl.querySelector('input[name="updates[]"]');
    if (!input) return;
    var next = parseInt(input.value, 10) + parseInt(btn.dataset.delta, 10);
    input.value = next < 0 ? 0 : next;
  });

  /* ---------- product gallery ---------- */
  var mainImg = document.getElementById('PdpMainImage');
  if (mainImg) {
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        mainImg.src = t.dataset.thumb;
        document.querySelectorAll('[data-thumb]').forEach(function (o) {
          o.setAttribute('aria-current', o === t ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------- mobile filter drawer ---------- */
  var fToggle = document.querySelector('[data-filter-toggle]');
  if (fToggle) {
    fToggle.addEventListener('click', function () {
      var panel = document.querySelector('[data-filters]');
      if (panel) panel.classList.toggle('open');
    });
  }

  /* ---------- category rail: nudge into view on mobile ---------- */
  var rail = document.querySelector('[data-cats]');
  if (rail) {
    var current = rail.querySelector('[aria-current="page"]');
    if (current && rail.scrollWidth > rail.clientWidth) {
      rail.scrollLeft = Math.max(0, current.offsetLeft - 20);
    }
  }

  /* ---------- product page: variants, price, add-ons ---------- */
  var form = document.querySelector('[data-pdp-form]');
  if (!form) return;

  var variantsEl = document.querySelector('[data-variant-json]');
  var variants = [];
  try { variants = JSON.parse(variantsEl.textContent); } catch (err) { variants = []; }

  var idField = form.querySelector('[data-variant-id]');
  var priceEl = document.querySelector('[data-price]');
  var totalEl = document.querySelector('[data-total]');
  var stickyEl = document.querySelector('[data-sticky-total]');
  var atcBtn = form.querySelector('[data-atc-btn]');
  var qtyInput = form.querySelector('[data-qty-input]');

  function selectedOptions() {
    var out = [];
    form.querySelectorAll('[data-variant-option]:checked').forEach(function (r) { out.push(r.value); });
    return out;
  }

  function currentVariant() {
    var chosen = selectedOptions();
    if (!chosen.length) {
      return variants.filter(function (v) { return String(v.id) === String(idField.value); })[0] || variants[0];
    }
    return variants.filter(function (v) {
      return chosen.every(function (val, i) { return v.options[i] === val; });
    })[0];
  }

  function addonTotal() {
    var sum = 0;
    form.querySelectorAll('[data-addon]:checked').forEach(function (box) {
      sum += parseInt(box.dataset.addonPrice, 10) || 0;
    });
    return sum;
  }

  function refresh() {
    var v = currentVariant();
    var qty = Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1);

    if (v) {
      idField.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        if (!v.available) atcBtn.textContent = 'Sold out';
      }
    }

    var base = v ? v.price : parseInt(form.dataset.basePrice, 10);
    var total = (base * qty) + addonTotal();

    if (totalEl) totalEl.textContent = money(total);
    if (stickyEl) stickyEl.textContent = money(total);
    if (atcBtn && v && v.available) {
      atcBtn.innerHTML = 'Add to bag &middot; <span data-total>' + money(total) + '</span>';
      totalEl = atcBtn.querySelector('[data-total]');
    }
  }

  form.addEventListener('change', function (e) {
    var row = e.target.closest('.addon');
    if (row) row.classList.toggle('on', e.target.checked);
    refresh();
  });
  if (qtyInput) qtyInput.addEventListener('input', refresh);
  refresh();

  /* ---------- submit: main product plus any add-ons, one request ---------- */
  form.addEventListener('submit', function (e) {
    var addons = form.querySelectorAll('[data-addon]:checked');
    if (!addons.length) return; // plain form post is fine

    e.preventDefault();
    if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Adding…'; }

    var qty = Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1);
    var v = currentVariant();
    var stamp = 'SAT-' + Date.now().toString(36).toUpperCase();

    var items = [{
      id: Number(v.id),
      quantity: qty,
      properties: { 'Order group': stamp }
    }];

    addons.forEach(function (box) {
      var label = box.closest('.addon').querySelector('.an');
      items.push({
        id: Number(box.dataset.addonId),
        quantity: qty,
        properties: {
          'For': (v && v.title && v.title !== 'Default Title')
            ? document.querySelector('.pdp h1').textContent.trim() + ' — ' + v.title
            : document.querySelector('.pdp h1').textContent.trim(),
          'Order group': stamp,
          '_service': (label ? label.textContent.trim() : 'Finishing')
        }
      });
    });

    fetch(S.addUrl || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || d.message || 'Could not add to bag'); });
        return r.json();
      })
      .then(function () { window.location.href = S.cartUrl || '/cart'; })
      .catch(function (err) {
        if (atcBtn) { atcBtn.disabled = false; refresh(); }
        var msg = document.createElement('div');
        msg.className = 'notice';
        msg.style.marginTop = '12px';
        msg.style.borderColor = 'var(--madder)';
        msg.textContent = err.message +
          '. Check that the add-on variant IDs in Theme settings match real products in your store.';
        form.appendChild(msg);
      });
  });
})();

/* ============================================================
   Sattika — mobile behaviours
   Added after a pass on a real phone width. Three things were
   missing or broken:
     1. the burger button had no handler at all
     2. search was display:none on phones with no replacement
     3. three announcement messages stacked instead of rotating
   ============================================================ */
(function () {
  'use strict';

  /* ---------- drawer ---------- */
  var drawer = document.querySelector('[data-drawer]');
  var scrim = document.querySelector('[data-scrim]');
  var burger = document.querySelector('[data-burger]');

  if (drawer && scrim && burger) {
    var lastFocus = null;

    function focusables() {
      return Array.prototype.filter.call(
        drawer.querySelectorAll('a[href],button,input,summary,[tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null || el.tagName === 'SUMMARY'; }
      );
    }

    function openDrawer() {
      lastFocus = document.activeElement;
      // the scrim already sits at opacity 0 in CSS, so no paint-wait
      // trick is needed; rAF would stall in a backgrounded tab.
      scrim.classList.add('open');
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('drawer-open');
      var f = focusables();
      if (f.length) f[0].focus();
    }

    function closeDrawer() {
      scrim.classList.remove('open');
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('drawer-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    burger.addEventListener('click', openDrawer);
    scrim.addEventListener('click', closeDrawer);
    Array.prototype.forEach.call(document.querySelectorAll('[data-drawer-close]'), function (b) {
      b.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('open')) return;
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    // a resize up to desktop should not leave the drawer stranded open
    window.addEventListener('resize', function () {
      if (window.innerWidth > 900 && drawer.classList.contains('open')) closeDrawer();
    });
  }

  /* ---------- rotating announcement bar ---------- */
  var promo = document.querySelector('.promo .wrap');
  if (promo) {
    var msgs = promo.querySelectorAll('span');
    if (msgs.length > 1) {
      var i = 0;
      msgs[0].classList.add('on');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var tick = function () {
        // only rotate while the stacked layout is active
        if (window.innerWidth > 760) {
          Array.prototype.forEach.call(msgs, function (m) { m.classList.add('on'); });
          return;
        }
        Array.prototype.forEach.call(msgs, function (m) { m.classList.remove('on'); });
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('on');
      };
      if (!reduce) window.setInterval(tick, 4200);
      window.addEventListener('resize', function () {
        if (window.innerWidth > 760) {
          Array.prototype.forEach.call(msgs, function (m) { m.classList.add('on'); });
        } else {
          Array.prototype.forEach.call(msgs, function (m) { m.classList.remove('on'); });
          msgs[i].classList.add('on');
        }
      });
    }
  }

  /* ---------- category rail: fade only when it really overflows ---------- */
  var cats = document.querySelector('[data-cats]');
  if (cats) {
    var nav = cats.closest('nav.cats');
    var mark = function () {
      if (!nav) return;
      var more = cats.scrollWidth - cats.clientWidth - cats.scrollLeft > 8;
      nav.setAttribute('data-overflow', more ? 'true' : 'false');
    };
    mark();
    cats.addEventListener('scroll', mark, { passive: true });
    window.addEventListener('resize', mark);
  }

  /* ---------- filter sheet: give it a Done button on mobile ---------- */
  var panel = document.querySelector('[data-filters]');
  var toggle = document.querySelector('[data-filter-toggle]');
  if (panel && toggle) {
    var done = document.createElement('button');
    done.type = 'button';
    done.className = 'btn gold filters-done';
    done.textContent = 'Show results';
    document.body.appendChild(done);

    var sync = function () {
      var open = panel.classList.contains('open');
      done.classList.toggle('show', open && window.innerWidth <= 1000);
      document.body.classList.toggle('drawer-open', open && window.innerWidth <= 1000);
    };
    toggle.addEventListener('click', function () { window.setTimeout(sync, 0); });
    done.addEventListener('click', function () { panel.classList.remove('open'); sync(); });
    window.addEventListener('resize', sync);
  }
})();
(function(){"use strict";var mainImg=document.getElementById("PdpMainImage");var variantsEl=document.querySelector("[data-variant-json]");var skuEl=document.querySelector(".sku");if(!variantsEl)return;var variants=[];try{variants=JSON.parse(variantsEl.textContent)}catch(err){variants=[]}var form=document.querySelector("[data-pdp-form]");if(!form)return;var skuPrefix=skuEl?skuEl.textContent.split("·")[0].trim():"";function selectedOptions(){var out=[];form.querySelectorAll("[data-variant-option]:checked").forEach(function(r){out.push(r.value)});return out}function currentVariant(){var chosen=selectedOptions();if(!chosen.length)return null;return variants.filter(function(v){return chosen.every(function(val,i){return v.options[i]===val})})[0]}function syncGallery(){var v=currentVariant();if(!v)return;if(mainImg&&v.featured_image&&v.featured_image.src){var src=v.featured_image.src;mainImg.src=src+(src.indexOf("?")===-1?"?":"&")+"width=1000";document.querySelectorAll("[data-thumb]").forEach(function(o){var base=o.dataset.thumb?o.dataset.thumb.split("?")[0]:"";o.setAttribute("aria-current",base===src.split("?")[0]?"true":"false")})}if(skuEl&&v.sku){skuEl.textContent=(skuPrefix?skuPrefix+" · ":"")+v.sku}}form.addEventListener("change",syncGallery);syncGallery()})();